

import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';

import { Button, Input } from 'antd';
import isEqual from 'lodash/isEqual';
import keys from 'lodash/keys';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import SimpleChoices from 'src/components/common/simple-choices';

const clsPrefix = 'section-welcome';

const I_AM_CHOICES = [
  {
    label: 'Agent',
    value: 'agent',
  },
  {
    label: 'Buyer',
    value: 'buyer',
  },
];

class SectionWelcome extends Component {
  static propTypes = {
    form: PropTypes.object,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
  };

  needsPhone = (values) => {
    return values.type === 'agent';
  };

  handleSubmit = (e) => {
    // TODO
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      const needsPhone = this.needsPhone(values);
      if (err) {
        if (needsPhone || !isEqual(keys(err), ['phone'])) {
          return null;
        }
      }
      if (this.needsPhone(values)) {
        await this.props.handleSubmit(values);
      } else {
        await this.props.handleSubmit(omit(values, ['phone']));
      }
      this.props.form.resetFields();
      return null;
    });
  };

  render() {
    const { getFieldDecorator, getFieldsValue } = this.props.form;
    const { submitting } = this.props;
    const values = getFieldsValue(['name', 'email', 'type', 'phone']);
    const needsPhone = this.needsPhone(values);
    return (
      <div className={`${clsPrefix}`}>
        <div className={`${clsPrefix}__welcome-text`}>
          <h2>Welcome!</h2>
          <div>To access this disclosure packet, please register below</div>
        </div>
        <Form
          onSubmit={this.handleSubmit}
          className={`${clsPrefix}__welcome-form`}
          key={needsPhone}
        >
          <Form.Item label="I am a...">
            {getFieldDecorator('type', {
              preserve: true,
              rules: [
                {
                  required: true,
                  message: 'Field is required',
                },
              ],
            })(<SimpleChoices choices={I_AM_CHOICES} />)}
          </Form.Item>
          <Form.Item label="Full Name">
            {getFieldDecorator('name', {
              preserve: true,
              rules: [
                {
                  required: true,
                  message: 'Name is required',
                },
              ],
            })(<Input />)}
          </Form.Item>
          <Form.Item label="Email">
            {getFieldDecorator('email', {
              preserve: true,
              rules: [
                {
                  type: 'email',
                  message: 'Not a valid email',
                },
                {
                  required: true,
                  message: 'Email is required',
                },
              ],
            })(<Input />)}
          </Form.Item>
          <div className={`${clsPrefix}__phone-row`}>
            {needsPhone ? (
              <Form.Item label="Phone">
                {getFieldDecorator('phone', {
                  initialValue: values.phone,
                  preserve: true,
                  rules: [
                    {
                      required: true,
                      message: 'Phone is required',
                    },
                  ],
                })(<Input />)}
              </Form.Item>
            ) : null}
          </div>
          <p className="sm-font-size">
            By clicking <b>Continue</b> you are opting to share these details
            with the listing agent and their team.
            <a
              className="margin-left-sm"
              href="https://www.glide.com/resources/privacy-center/"
            >
              Learn More
            </a>
          </p>

          <Button
            type="primary"
            loading={submitting}
            htmlType="submit"
            className={`${clsPrefix}__continue-button`}
          >
            Continue
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(SectionWelcome);
